export const EXAMPLE = {
  '2': 'https://qnm.hunliji.com/Fv1a_lOmc0O9E2pdghGM0GzmWATN',
  '6': 'https://qnm.hunliji.com/Fjf99eG_DDLw4XpK3vHD7d0cD0Lw',
  '7': 'https://qnm.hunliji.com/FpyqDQz3Z6wa7zusLobPsZPFuhef',
  '8': 'https://qnm.hunliji.com/FmTjY_4U_-X3b5GUrIC5r5qMA6s0',
  '9': 'https://qnm.hunliji.com/FvcqpSywGVbC9iBI50pGYTdV2LjF',
  '11':
    'https://qnm.hunliji.com/camel-6c6560fd-b41c-4636-ab54-3731ef2e6ce6.png',
  '12': 'https://qnm.hunliji.com/FpwrjlQ6EZ7L6IXkPLvXwWfoamXR',
  '13': 'https://qnm.hunliji.com/FjSlqdpOySPgDNzWkNefmCWdjD0V',
  '14': 'https://qnm.hunliji.com/FkWN-TCBNth4QHAyKavs4lmNNp9h'
}
